<script setup lang="ts">
import { EventListDisplayType } from "~/types/Event";

defineProps<{
  cardType: EventListDisplayType;
}>();
</script>

<template>
  <div
    v-if="cardType === EventListDisplayType.CardLarge"
    class="py-6 md:py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 px-4 md:px-0"
  >
    <BaseSkeletonLoader
      v-for="eventIndex in 12"
      :key="eventIndex"
      :width="300"
      :height="250"
    />
  </div>
  <div
    v-else
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-4 md:mt-4"
  >
    <BaseSkeletonLoader
      v-for="eventIndex in 12"
      :key="eventIndex"
      :width="300"
      :height="100"
    />
  </div>
</template>
